var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tag',{class:{ 'adm-tag--primary': _vm.resolvedType === 'primary' },attrs:{"type":_vm.elTagType,"size":_vm.size,"effect":_vm.effect,"disable-transitions":""}},[_vm._v(_vm._s(_vm.resolvedText))])
}
var staticRenderFns = []

export { render, staticRenderFns }